const variables = require('variables');
const waitForFinalEvent = require('utils/waitForFinalEvent');

/**
 * Match a function (width of screen) with an array of number (bootstrap breakpoints) and trigger a custom event
 * @param {fuction} funcWidthHeight function to calculate the value
 * @param {Array} arrayOfBreakpoint array to compare with the returned number
 * @param {string} nameOfEvent name of event to trigger when the breakpoint change
 * @return {undefined}
 */
function breackpointsEvents(funcWidthHeight, arrayOfBreakpoint, nameOfEvent) {
	let windowWidth;
	let i = 0;
	let currentBreakpoint = -1;
	const lenarrayOfBreakpoint = arrayOfBreakpoint.length;
	function breackpointsHandler() {
		windowWidth = funcWidthHeight();
		for (i = 0; i < lenarrayOfBreakpoint; i += 1) {
			if (windowWidth < arrayOfBreakpoint[i]) {
				break;
			}
		}
		if (currentBreakpoint !== i || !currentBreakpoint) {
			variables.$window.trigger(nameOfEvent, [currentBreakpoint, i]);
			currentBreakpoint = i;
		}
	}

	const breackpointsHandlerDebounced = waitForFinalEvent(breackpointsHandler, 250, 'BSBreakpoints');

	breackpointsHandler();
	variables.$window.resize(breackpointsHandlerDebounced);
}

module.exports = breackpointsEvents;



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/breackpointsEvents.js
 **/